import { render, staticRenderFns } from "./IronOreIdxPrice.vue?vue&type=template&id=dadaa540&scoped=true"
import script from "./IronOreIdxPrice.vue?vue&type=script&lang=js"
export * from "./IronOreIdxPrice.vue?vue&type=script&lang=js"
import style0 from "./IronOreIdxPrice.vue?vue&type=style&index=0&id=dadaa540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadaa540",
  null
  
)

export default component.exports